import { Component, computed, input } from '@angular/core';
import { IDynamicElement, TextHtmlComponent } from '@sirius/common';
import { IProductSpecifications } from 'shared/models';

@Component({
    selector: 'ur-product-specifications',
    templateUrl: './product-specifications.component.html',
    styleUrl: './product-specifications.component.scss',
    imports: [TextHtmlComponent],
    host: {
        class: 'ur-product-specifications sir-text-style-paragraph-m-default',
    },
})
export class ProductSpecificationsComponent implements IDynamicElement<IProductSpecifications> {
    readonly config = input<IProductSpecifications>();

    protected readonly items = computed(() => this.config()?.items ?? []);
}
